// Mode-aware copy for manager-bucket dock sections (Slice B2.5 pattern).

import type { PrimaryMode } from "@/components/lead/sections/LeadWorkspaceHeaderAccess";

export function formatKbGapsBodyLine(
  count: number,
  currentMode: PrimaryMode | null,
): string {
  const noun = count === 1 ? "item needs" : "items need";
  switch (currentMode) {
    case "knowledgebase":
      return `${count} open gap inbox ${noun} review in Knowledge Base.`;
    case "trainingAuthor":
      return `${count} KB gap ${count === 1 ? "item" : "items"} from training work ${count === 1 ? "needs" : "need"} review.`;
    case "aiPrompting":
      return `${count} knowledge gap ${count === 1 ? "is" : "are"} waiting while you edit prompts.`;
    default:
      return `${count} open knowledge-base gap ${count === 1 ? "item" : "items"} ${count === 1 ? "needs" : "need"} attention.`;
  }
}

export function formatAiPromptingSuggestionsBodyLine(
  count: number,
  currentMode: PrimaryMode | null,
): string {
  const noun = count === 1 ? "suggestion awaits" : "suggestions await";
  switch (currentMode) {
    case "aiPrompting":
      return `${count} prompt ${noun} your review in this panel.`;
    default:
      return `${count} AI prompt ${noun} review in AI Prompting.`;
  }
}
